import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FetchCallbacksContext } from '../../FetchCallbacks';
import useGlobalVariables from '../../../hooks/useGlobalVariables';
import FormBuilderCredasView from '../view/FormBuilderCredasView';

const TAB_VALUES = {
  AUTHENTICATION: 0,
  SETTINGS: 1
};

const FormBuilderCredasEngine = ({
  formId,
  integrationData: receivedIntegrationData
}) => {
  const { setIsLoading } = useGlobalVariables();
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const integrationType = 'credas';
  const [apiKey, setApiKey] = useState('');
  const [integrationData, setIntegrationData] = useState(
    receivedIntegrationData
  );
  const [activeTab, setActiveTab] = useState(TAB_VALUES.AUTHENTICATION);
  const [credasConnected, setCredasConnected] = useState(
    receivedIntegrationData && receivedIntegrationData.id !== 'new'
  );
  const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = useState(false);
  const [isEmailDialogOpen, setIsEmailDialogOpen] = useState(false);
  const [templateId, setTemplateId] = useState(null);

  const getCurrentInfo = () => {
    fetchAPI(
      `/scheduler/v1/integration/${integrationData.id}/serverdetails`
    ).then(res => {
      if (!res || !res.integrationServerDetails) {
        return;
      }
      setApiKey(res.integrationServerDetails?.privateKey || '');
    });
  };

  useEffect(() => {
    if (integrationData && integrationData.id && integrationData.id !== 'new') {
      getCurrentInfo();
    }
  }, [integrationData]);

  const onConnectBtnClicked = useCallback(() => {
    setIsLoading(true);
    fetchAPI(`/scheduler/v1/integration/connect/${integrationType}`, {
      method: 'PUT',
      body: {
        ftp_details: {
          privateKey: apiKey
        },
        integration: {
          integrationType: integrationType,
          assetId: formId
        }
      },
      handleResponse: r => {
        const newIntegrationId = r.headers.map.location;
        setIntegrationData({ id: newIntegrationId });
        setCredasConnected(true);
        setIsLoading(false);
        openSnackbar(
          'success',
          `snackbars.integrations.${integrationType}_success`
        );
      }
    }).catch(() => {
      setIsLoading(false);
      openSnackbar(
        'error',
        `snackbars.integrations.${integrationType}_failure`
      );
    });
  }, [formId, apiKey]);

  const onDisconnectBtnClicked = useCallback(() => {
    setIsDisconnectDialogOpen(false);
    if (
      !integrationData ||
      !integrationData.id ||
      integrationData.id === 'new'
    ) {
      return;
    }
    fetchAPI(
      `/forms/v1/forms/${formId}/integration/${integrationData.id}/deactivate?integrationType=credas`,
      {
        method: 'DELETE'
      }
    )
      .then(res => {
        fetchAPI(`/forms/v1/forms/${formId}`).then(r => {
          openSnackbar(
            'success',
            'snackbars.integrations.credas_disconnect_success'
          );
        });
      })
      .catch(() => {
        openSnackbar(
          'error',
          'snackbars.integrations.credas_disconnect_failure'
        );
      });
  }, [integrationData]);

  const onEditLOETemplateClicked = () => {
    setIsEmailDialogOpen(true);
    setTemplateId('00000000-0000-0000-0000-000000000300');
  };

  const onEmailDialogConfirmed = () => {};

  const viewProps = {
    activeTab,
    setActiveTab,
    apiKey,
    setApiKey,
    credasConnected,
    onConnectBtnClicked,
    isDisconnectDialogOpen,
    setIsDisconnectDialogOpen,
    onDisconnectBtnClicked,
    onEditLOETemplateClicked,
    onEmailDialogConfirmed,
    isEmailDialogOpen,
    setIsEmailDialogOpen,
    templateId,
    TAB_VALUES
  };

  return <FormBuilderCredasView {...viewProps} />;
};

export default FormBuilderCredasEngine;
